import NavLinkAdapter from '@fuse/core/NavLinkAdapter';
import FuseUtils from '@fuse/utils';
import Icon from '@material-ui/core/Icon';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { makeStyles } from '@material-ui/core/styles';
import * as Actions from 'app/store/actions';
import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import FuseNavBadge from '../FuseNavBadge';

const useStyles = makeStyles(theme => ({
	item: props => ({
		height: 40,
		width: 'calc(100% - 5px)',
		borderRadius: '0 20px 20px 0',
		paddingRight: 12,
		paddingLeft: props.itemPadding > 80 ? 80 : props.itemPadding,
		'&.active': {
			backgroundColor: theme.palette.secondary.main,
			color: `${theme.palette.secondary.contrastText}!important`,
			// pointerEvents: 'none',
			transition: 'border-radius .15s cubic-bezier(0.4,0.0,0.2,1)',
			'& .list-item-text-primary': {
				color: 'inherit'
			},
			'& .list-item-icon': {
				color: 'inherit'
			},
			'&:hover': {
				backgroundColor: `${theme.palette.secondary.main}!important`,
				color: "red"
			},
		},
		'& .list-item-icon': {
			marginRight: 16
		},
		'& .list-item-text': {},
		color: theme.palette.text.primary,
		cursor: 'pointer',
		textDecoration: 'none!important'
	})
}));

function FuseNavVerticalItem(props) {
	const dispatch = useDispatch();
	const userRole = useSelector(({ auth }) => auth.user.role);
	const { item, nestedLevel } = props;
	const classes = useStyles({
		itemPadding: nestedLevel > 0 ? 40 + nestedLevel * 16 : 24
	});
	const { t } = useTranslation('navigation');

	if (!FuseUtils.hasPermission(item.auth, userRole)) {
		return null;
	}

	let userData = JSON.parse(localStorage.getItem('userData'));
	let userType = userData && userData.userType;

	let url = window.location.href;
	let pathname = url.split('/');

	let obj = {
		"manage-tastes": ['add-tastes'],
		"manage-places": ['add-place', 'update-place'],
		"manage-users-places": ['add-user-place', 'update-user-place'],
		"suggetion-edit": ['view-suggetion'],
		"manage-users": ['update-user'],
		"manage-owners": ['update-owner', 'view-owner-places'],
		"manage-features": ['update-feature', "add-features"],
		"manage-language": ['add-languages'],
		"manage-term": ['add-terms'],
		"manage-order": ['view-order'],
		"manage-newslatter": ['update-newslatter','add-newslatter'],
		"manage-contentpage": ['update-contentpage','add-contentpage'],
	}

	let split_data = userType === 'Owner' ? pathname[4] : pathname[3];
	let isActive = userType === 'Owner' ? obj[item && item.url && item.url.split('/')[2]] && obj[item && item.url && item.url.split('/')[2]].includes(split_data) : obj[item && item.url.substring(1)] && obj[item && item.url.substring(1)].includes(split_data);

	return (
		<ListItem
			button
			component={NavLinkAdapter}
			to={item.url}
			// activeClassName="active"
			className={clsx(classes.item, isActive ? 'list-item active' : 'list-item')}
			onClick={ev => dispatch(Actions.navbarCloseMobile())}
			exact={item.exact}
		>
			{item.icon && (
				<Icon className="list-item-icon text-16 flex-shrink-0" color="action">
					{item.icon}
				</Icon>
			)}

			<ListItemText
				className="list-item-text"
				primary={item.translate ? t(item.translate) : item.title}
				classes={{ primary: 'text-14 list-item-text-primary' }}
			/>

			{item.badge && <FuseNavBadge badge={item.badge} />}
		</ListItem>
	);
}



const NavVerticalItem = withRouter(React.memo(FuseNavVerticalItem));

export default NavVerticalItem;
